import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
import { useAppDispatch } from '../../../../store/hooks';
import { setSidebar } from '../../../../store/sidebarDrawer';

const useStyles = makeStyles()({
    button: {
        padding: '10px',
    },
});

interface Props {
    listName: string;
}

export default function GroupContactsHeader({ listName }: Props) {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    const handleClick = () => {
        dispatch(setSidebar({ groupsList: null }));
    };

    return (
        <Grid container direction="row" wrap="nowrap" alignItems="center" spacing={2}>
            <Grid item xs="auto">
                <Tooltip title="All Groups">
                    <IconButton onClick={handleClick} className={classes.button} size="large">
                        <ArrowBackIcon />
                    </IconButton>
                </Tooltip>
            </Grid>
            <Grid item xs="auto">
                <Typography variant="h6" component="h2" noWrap>
                    {listName}
                </Typography>
            </Grid>
        </Grid>
    );
}
